var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
import { isTouchDevice } from "./touch";
import { isMobile, isPortrait, onIsMobileChanged, onIsPortraitChanged } from "./mobile";
export class DeviceManager {
    get isMobilePortraitTouchDevice() {
        return this.isMobile && this.isPortrait && this.isTouchDevice;
    }
    get isMobileNotTouchDevice() {
        return this.isMobile && !this.isTouchDevice;
    }
    constructor() {
        this.isMobile = isMobile();
        this.isPortrait = isPortrait();
        this.isTouchDevice = isTouchDevice();
        window.matchMedia(onIsMobileChanged).addEventListener("change", (e) => {
            this.isMobile = e.matches;
        });
        window.matchMedia(onIsPortraitChanged).addEventListener("change", (e) => {
            this.isPortrait = e.matches;
        });
    }
}
__decorate([
    observable
], DeviceManager.prototype, "isMobile", void 0);
__decorate([
    observable
], DeviceManager.prototype, "isPortrait", void 0);
__decorate([
    computed
], DeviceManager.prototype, "isMobilePortraitTouchDevice", null);
__decorate([
    computed
], DeviceManager.prototype, "isMobileNotTouchDevice", null);
